import { render } from "./otherBank.vue?vue&type=template&id=ac078866&scoped=true"
import script from "./otherBank.vue?vue&type=script&lang=js"
export * from "./otherBank.vue?vue&type=script&lang=js"

import "./otherBank.vue?vue&type=style&index=0&id=ac078866&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac078866"]])

export default __exports__